<nav class="app-breadcrumb" [attr.aria-label]="'header.breadcrumb.ariaLabel' | translate">
  @for (crumb of breadcrumbs; track crumb.url + crumb.label; let last = $last) {
    @if (last) {
      <span class="app-breadcrumb__current" aria-current="page">{{ crumb.label | translate }}</span>
    } @else {
      <a class="app-breadcrumb__link" [routerLink]="crumb.url">{{ crumb.label | translate }}</a>
      <span class="app-breadcrumb__separator" aria-hidden="true">›</span>
    }
  }
</nav>
